import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControlQuestionProcessor } from './form-control-question-processor.component';
import { FormDropdownQuestionModule } from '../form-dropdown-question/form-dropdown-question.module';
import { FormInputQuestionModule } from '../form-input-question/form-input-question.module';
import { FormRadioGroupQuestionModule } from '../form-radio-group-question/form-radio-group-question.module';
import { FormCheckboxQuestionModule } from '../form-checkbox-question/form-checkbox-question.module';

@NgModule({
  declarations: [
    FormControlQuestionProcessor
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormDropdownQuestionModule,
    FormInputQuestionModule,
    FormRadioGroupQuestionModule,
    FormCheckboxQuestionModule
  ],
  exports: [
    FormControlQuestionProcessor
  ]
})
export class FormControlQuestionProcessorModule {
}
